module.exports = ".anchor-tag {\n  text-decoration: underline;\n  cursor:pointer;\n  color: #007bff;\n}\n\n.anchor-tag-w9Form {\n  text-decoration: underline;\n  cursor:auto;\n  color:#808080;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/download-multiple-documents/download-multiple-documents.component.css
// module id = ./src/app/components/download-multiple-documents/download-multiple-documents.component.css
// module chunks = main